import {
  START_MANUAL_JOURNEY,
  MANUAL_ORDERS_CLEAR,
  SET_SELECTED_MANUAL_ORDER,
  SET_MANUAL_PAYMENT,
} from 'helpers/types';

const INITIAL_STATE = {
  started: false,
  selectedOrder: {},
  payment: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case START_MANUAL_JOURNEY:
      return {
        ...INITIAL_STATE,
        manualOrders: state.manualOrders,
        started: true,
      };
    case SET_SELECTED_MANUAL_ORDER:
      return {
        ...state,
        selectedOrder: action.payload,
      };
    case SET_MANUAL_PAYMENT:
      return {
        ...state,
        payment: action.payload,
      };
    case MANUAL_ORDERS_CLEAR:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}
